// extracted by css-extract-rspack-plugin
export default {"cls1":"Menu-cls1_wA1","cls2":"Menu-cls2_dKR Menu-cls1_wA1"};